<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Bauartklasse",
  components: {},
});
</script>

<template>
  <p>
    <strong><em>Bauartklassen</em></strong>
  </p>
  <ul>
    <li>
      <strong>BAK I</strong>
      <ul>
        <li><em>Aussenwände</em>: Massiv (Mauerwerk, Beton u.ä.)</li>
      </ul>
    </li>
    <li>
      <strong>BAK II</strong>
      <ul>
        <li>
          <em>Aussenwände</em>: Stahl- oder Holzfachwerk mit Stein- oder Glasfüllung, Stahl-oder Stahlbetonkonstruktion
          mit Wandplattenverkleidung aus anderem Material als Holz oder Kunststoff (z.B. Profilblech, Asbestzement)
        </li>
      </ul>
    </li>
    <li>
      <strong>BAK III</strong>
      <ul>
        <li>
          <em>Aussenwände</em>: Holz, Holzfachwerk mit Lehmfüllung, Holzkonstruktion mit Verkleidung jeglicher Art,
          Stahl- oder Stahlbetonkonstruktion mit Wandplattenverkleidung aus Holz oder Kunststoff, Gebäude mit einer oder
          mehreren offenen Seiten
        </li>
      </ul>
    </li>
    <li>
      <strong>BAK IV</strong>
      <ul>
        <li><em>Aussenwände</em>: Wie BAK I oder BAK II, jedoch mit weichem Dach wie z.B: Reet, Stroh oder Schilf.</li>
      </ul>
    </li>
    <li>
      <strong>BAK V</strong>
      <ul>
        <li><em>Aussenwände</em>: Wie BAK III, jedoch mit weichem Dach wie z.B: Reet, Stroh oder Schilf.</li>
      </ul>
    </li>
  </ul>

  <p>
    <strong><em>Fertighausklassen</em></strong>
  </p>
  <ul>
    <li>
      <strong>FHG 1</strong>
      <ul>
        <li>
          <em>Aussenwände</em>: In allen Teilen - einschließlich der tragenden Konstruktion - aus feuerbeständigen
          Bauteilen
        </li>
      </ul>
    </li>
    <li>
      <strong>FHG 2</strong>
      <ul>
        <li>
          <em>Aussenwände</em>: Fertighaus in Leichtbauweise, Fundament massiv, tragende Konstruktion aus Stahl, Holz,
          Leichtbauteilen oder dgl., Umfassungswände und tragende Konstruktion nach innen und außen mit feuerhemmenden,
          nichtbrennbaren Baustoffen ummantelt bzw. verkleidet (z.B. Putz, Klinker, Gipsplatten; nicht jedoch Metall
          oder Metallfolien
        </li>
      </ul>
    </li>
    <li>
      <strong>FHG 3</strong>
      <ul>
        <li><em>Aussenwände</em>: Wie FGH 2, jedoch ohne feuerhemmende Ummantelung bzw. Verkleidung</li>
      </ul>
    </li>
  </ul>
</template>

<style scoped></style>
